import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const SendAlternative: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.6378 4.4461L6.28782 8.79618L6.99594 9.50401L7.70406 10.2118L10.848 7.06796L13.9919 3.92408V12.966V22.008H7.99194H1.99194V23.004V24H8.99994H16.0079V13.962V3.92408L19.1519 7.06796L22.2958 10.2118L23.0039 9.50401L23.7121 8.79618L19.362 4.4461C16.9695 2.05354 15.0066 0.0960083 14.9999 0.0960083C14.9933 0.0960083 13.0304 2.05354 10.6378 4.4461Z'
        fill={fill}
      />
    </svg>
  )
}

export default SendAlternative
